import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  colorRed: {
    color: theme.palette.text.red,
  },
  colorGreen: {
    color: theme.palette.text.rootColor,
  },
  switchCls: {
    margin: '-6px auto',
  },
  customAccordion: {
    '&.Mui-expanded': {
      margin: 0,
    },
    '& .MuiAccordionSummary-content': {
      margin: '11px 0 8px !important',
    },
  },
  expends: {
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'none',
    },
    '& .MuiTouchRipple-root': {
      display: 'none',
    },
  },
  cmAccHeader: {
    padding: '0 20px',
    background: 'rgba(234,233,232,0.2)',
    color: '#282525',
    minHeight: '48px !important',
  },
  fundsAccHeader: {
    cursor: 'default !important',

    '& .MuiIconButton-edgeEnd': {
      margin: '12px 0 12px 12px',
      padding: 0,
    },
  },
  cmAccDetail: {
    padding: '25px 20px',
  },
  accordionHeader: {
    textAlign: 'center',
    letterSpacing: 0,
    fontWeight: 'bold',
    fontSize: 13,
    color: '#282525',
    display: 'flex',
    alignItems: 'center',
  },
  accordionHeaderFundName: {
    padding: '4px 0',
  },
  accordionToggleLabel: {
    letterSpacing: 0,
    fontWeight: 'bold',
    fontSize: 13,
    cursor: 'default',
  },
  progressIndication: {
    marginLeft: '2rem',
  },
  flexGap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gridGap: '1rem',
  },
  errorCk: {
    color: theme.palette.error.main,
    marginTop: '4px',
    fontSize: '0.75rem',
  },
}));

export default useStyles;
